import React from "react";
import {
    DialogRoot,
    DialogTrigger,
    DialogContent,
    DialogHeader,
    DialogBody,
    DialogFooter,
    DialogTitle,
    DialogActionTrigger, Button,
} from "@chakra-ui/react";
import {Text, Portal} from "@chakra-ui/react";
import ChakraMarkdown from "./ChakraMarkdown";
import {AGB} from "./AGB";
import {Impressum} from "./Impressum";
import {DSGVO} from "./DSGVO";

const legalContent = { AGB, Impressum, DSGVO };

const LegalModal = ({type, triggerText}) => {
    const locale = navigator.language.startsWith("de") ? "de" : "en";
    const title = type;
    const body = legalContent[type][locale] || "Content not found.";

    return (
        <DialogRoot placement="top">
            <DialogTrigger asChild>
                {/* Trigger text */}
                <Text
                    as="span"
                    color="black"
                    cursor="pointer"
                    _hover={{textDecoration: "underline"}}
                >
                    {triggerText || type}
                </Text>
            </DialogTrigger>

            {/* Ensure the DialogContent renders in a portal */}
            <Portal>
                <DialogContent
                    position="fixed"
                    top="50%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    bg="white"
                    boxShadow="lg"
                    borderRadius="md"
                    maxW="500px"
                    p={6}
                >
                    <DialogHeader>
                        <DialogTitle fontSize="lg" fontWeight="bold">
                            {title}
                        </DialogTitle>
                    </DialogHeader>
                    <DialogBody
                        overflowY="auto"
                        maxH="60vh"
                        pr={4}>
                        <ChakraMarkdown markdown={body}/>
                    </DialogBody>
                    <DialogFooter>
                        <DialogActionTrigger asChild>
                            <Button>Close</Button>
                        </DialogActionTrigger>
                    </DialogFooter>
                </DialogContent>
            </Portal>
        </DialogRoot>
    );
};

export default LegalModal;